<template>
  <ModalRoot :closeByClickingOutside="true" @close="$emit('close')" :title="modalTitle">
    <div class="services-modal modal-dialog__content">
      <div class="services-modal__headline" v-html="headline" />

      <div class="services-modal__body">
        <div v-if="isMobile" class="services-modal__service" @click="$emit('toggleInsurancesDetailsModal')">
          <div class="services-modal__service--bar">
            <!--<Icon icon="info" class="services-modal__service--info" />-->
            <span class="services-modal__service--details">Szczegóły ubezpieczeń</span>
          </div>
        </div>
        <div v-for="(service, key) in services" :key="key" class="services-modal__service">
          <div @click="toggle(service, key)" :class="{
            'services-modal__service--bar': true,
            'services-modal__service--bar-open': dropdowns.services[key]}">
            <Icon v-if="!service.IsOptional || service.selected" icon="form-valid-check" class="services-modal__service--selected" />
            <i class="services-modal__service--title">{{ truncateTitle(service.Title) }}</i>
            
            <span v-if="!service.IsOptional && service.ServicePriceAll == '0'" class="services-modal__service--in-price">W cenie</span>
            <div v-else class="services-modal__service--expand">
              <template v-if="!isMobile && service.selected && !dropdowns.services[key]">
                <span>{{ service.selectedPeople }} os. /</span>
                <span class="price">{{ service.selectedTotalPrice }}</span>
                <span class="currency">zł</span>
              </template>
              <Icon v-if="service.IsOptional" icon="v" :class="{ 'rotated': dropdowns.services[key] }"/>
            </div>
          </div>

          <div v-if="dropdowns.services[key]" class="services-modal__service--dropdown">
            <p v-if="service.Description" v-html="service.Description" />

            <ServicePerPerson v-if="service.IsServicePerPerson" class="services-dropdown"
              :value="service" />

            <ServicePerReservation v-else class="services-dropdown"
              :value="service" />

            <div v-if="anySelected" class="services-modal__service--summary">
              <span v-if="service.selectedPeople" class="count">Wybrane dla {{ service.selectedPeople }} os. <template v-if="!isMobile">/ &nbsp;</template></span>
              <span>Cena razem:</span>
              <span class="price">{{ service.selectedTotalPrice }}<span class="currency">zł</span></span>
            </div>
          </div>
        </div>
      </div>

      <div class="services-modal__footer" :class="{'services-modal__footer--selected': anySelected}">
        <button v-if="!anySelected && isInsuranceService && !selectedMatchesServiceType" @click="$emit('close')" class="services-modal__button services-modal__button--close">Nie rozszerzam {{ serviceTitle }}</button>
        <button v-if="anySelected" @click="clear" class="services-modal__button services-modal__button--clear"><Icon icon="cross" /> Wyczyść wszystko</button>

        <div v-if="!anyStoredSelectedService && anySelected" class="services-modal__footer--button-summary">
          <span v-if="!isMobile">Wszystkie wybrane razem: <b>{{ selectedTotalPrice }}</b> zł</span>
          
          <button @click="applySelected" class="services-modal__button services-modal__button--select">
            <span v-if="isMobile">Wszystkie wybrane razem: <b>{{ selectedTotalPrice }}</b> zł</span>            
            Dodaj {{ serviceTitle }}</button>
        </div>

        <button v-if="anyStoredSelectedService && selectedSameAsStored && selectedMatchesServiceType"
          @click="$emit('close')" class="services-modal__button services-modal__button--select">Wróć</button>
        
        <button v-if="anyStoredSelectedService && !selectedSameAsStored"
          @click="applySelected" class="services-modal__button services-modal__button--select">Zapisz zmiany</button>
      </div>
    </div>
  </ModalRoot>  
</template>

<script>
import { truncate, cloneDeep, isEqual } from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'

import ServicePerPerson from '@/components/booking/additionalServices/ServicePerPerson'
import ServicePerReservation from '@/components/booking/additionalServices/ServicePerReservation'
import { INSURANCES_CODE } from '@/components/booking/types'
import Icon from '@/components/Icon'
import ModalRoot from '@/components/ModalRoot'
import MediaDetector from '@/utils/MediaDetector'

@Component({
  mixins: [
    MediaDetector,
  ],
  components: {
    ServicePerPerson,
    ServicePerReservation,
    ModalRoot,
    Icon,
  },
  props: {
    value: {
      type: Array,
      required: false,
    },
    headline: {
      type: String,
      required: false,
    },
    modalTitle: {
      type: String,
      required: false,
    },
    serviceTitle: {
      type: String,
      required: false,
    },
    serviceCode: {
      type: String,
      required: false,
    },
    storedSelectedServices: {
      type: Array,
      required: false,
    },
    storedAdditionalServices: {
      type: Array,
      required: false,
    },
  },
})
export default class ServiceModal extends Vue {
  services = cloneDeep(this.value)
  dropdowns = {
    services: this.services.map(() => false),
  }

  get anyStoredSelectedService () {
    return this.storedSelectedServices.length
  }
  
  get anySelected () {
    return this.services.some(service => service.selected)
  }

  get selected () {
    return this.services.filter(service => service.selected)
  }

  get isInsuranceService () {
    return this.serviceCode == INSURANCES_CODE
  }

  get selectedTotalPrice () {
    return this.selected
      .reduce((acc, service) => acc + service.selectedTotalPrice, 0)
  }

  get storedSelectedAdditionalService () {
    return this.storedAdditionalServices
      .find(service => service.code == this.serviceCode).services
      .filter(service => service.selected)
  }

  get selectedSameAsStored () {
    return isEqual(this.selected, this.storedSelectedAdditionalService)
  }

  get selectedMatchesServiceType () {
    return this.storedSelectedServices.some(service => service.type == this.serviceCode)
  }

  created () {
    this.toggleServicesDropdownIfSelected()
  }

  applySelected () {      
    log.debug('___ ServiceModal.applySelected ___', this.services)
    this.$emit('selected', this.services)
  }

  /**
   * @param {String} title
   */
  truncateTitle (title) {
    return this.isMobile ? title : truncate(title, { 'length': 55, 'separator': ' ' })
  }

  toggle (service, key) {
    if (!service.IsOptional) return

    for (const dropdown in this.dropdowns.services) {
      if (key == dropdown) Vue.set(this.dropdowns.services, dropdown, !this.dropdowns.services[dropdown])
    }
  }

  toggleServicesDropdownIfSelected () {
    this.services.forEach((service, i) => {
      if (service.selected) this.toggle(service, i)
    })
  }

  closeAllTabs (i) {
    Vue.set(this.dropdowns.services, i, false)
  }

  deselectServiceOptions (service) {
    service.selected = false
    service.selectedPeople = 0
    service.selectedAdults = 0
    service.selectedChildren = 0
    service.selectedTotalPrice = 0
    service.selectedIDs = ''
    service.options.forEach(option => { option.selected = false })
  }

  clear () {
    return this.services.forEach((service, i) => {
      if (!service.IsOptional) return
      
      this.closeAllTabs(i)
      this.deselectServiceOptions(service)
    })
  }
}
</script>

<style lang="scss" scoped>
.services-modal {
  padding: 0;
  align-items: initial;

  @include mediaFluid(tablet) {
    padding: 20px;
  }

  &__headline {
    text-align: left;
    color: #005CA9;
    font-size: 12px;
    font-family: 'Gotham Book';
    padding: 20px;

    @include mediaFluid(tablet) {
      font-size: 1.15em;
      padding: 0;
    }
  }

  &__body {
    width: 100%;

    @include mediaFluid(tablet) {
      margin: 10px auto 40px;
    }
  }

  &__services {
    width: 100%;
    margin: 10px auto 40px;
  }

  &__service {
    border-bottom: 1px solid #005CA9;
    color: #005CA9;

    &--bar {
      display: flex;
      align-items: center;
      padding: 12px 20px;
      cursor: pointer;

      @include mediaFluid(tablet) {
        padding-left: 10px;
        padding-right: 10px;
      }
    }

    &--bar-open {
      background: #005CA9;
      color: #fff;
    }

    &--details {
      text-transform: uppercase;
      font-size: 12px;
      font-weight: bold;
      margin-left: 10px;
    }

    &--selected {
      padding-right: 10px;
      color: #00C761;
    }

    &--title {
      font-family: 'Georgia';
      flex: 0 1 auto;
      
      @include mediaFluid(tablet) {
        font-size: 1.4em;
      }
    }

    &--info {
      font-size: 22px;
      
      @include mediaFluid(tablet) {
        margin-left: 8px;
      }
    }

    &--in-price {
      flex: auto;
      text-align: right;
      font-size: .85em;
      text-transform: uppercase;
      font-family: 'Gotham Book';
      font-weight: bold;
      padding-left: 10px;
      flex: 1 0 auto;
    }
  }

  &__service--dropdown {
    background-color: #EDEDED;
    padding-bottom: 20px;

    p {
      padding: 10px 20px;
      font-size: 12px;
      color: #535353;

      @include mediaFluid(tablet) {
        font-size: 14px;
        color: #005CA9;
        padding-top: 20px;
      }

      + .services-dropdown::before {
        content: '';
        position: absolute;
        top: 8px;
        left: -20px;
        width: calc(100% + 40px);
        height: 1px;
        background-color: #fff;

        @include mediaFluid(tablet) {
          display: none;
        }
      }
    }
  }

  &__service--expand {
    font-size: 13px;
    flex: auto;
    text-align: right;
    font-weight: bold;
    text-transform: uppercase;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: 40px;
    height: 18px;
    padding-left: 10px;

    .figure {
      font-size: 9px;
      margin-bottom: 3px;
      margin-left: 10px;

      &.rotated {
        transform: rotate(180deg);
      }
    }

    .currency {
      font-weight: normal;
      font-family: 'Gotham Book';
    }

    .price {
      font-size: 21px;
      line-height: 18px;
      margin: 0 2px 0 3px;
    }
  }

  &__service--summary {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: 1fr 1fr;
    grid-template-areas: "a c" "b c" ". .";
    align-items: center;
    text-align: right;
    padding: 10px;
    padding-left: 0;
    background-color: #fff;
    font-weight: bold;
    text-transform: uppercase;
    margin: 10px 20px 0;

    @include mediaFluid(tablet) {
      display: flex;
      justify-content: flex-end;
      padding: 10px 40px;
    }

    .price {
      font-size: 31px;
      margin-left: 12px;

      @include mediaFluid(tablet) {
        font-size: 1.8em;
        margin-left: 20px;
      }
    }

    .currency {
      font-size: 14px;
      font-weight: normal;
      margin-left: 2px;
      font-family: "Gotham Book";
    }

    span:first-child {
      grid-area: a;
    }

    span:nth-child(2) {
      grid-area: b;      
    }

    span:last-child {
      grid-area: c;      
    }

    @include mediaFluid(tablet) {
      span {
        grid-area: auto;
      }
    }
  }

  &__footer {
    text-align: center;
    
    @include mediaFluid(tablet) {
      margin: 10px auto 20px;
    }

    &--selected {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    
      @include mediaFluid(tablet) {
        margin-top: 25px;
        flex-direction: row;
      }
    }

    &--button-summary {
      width: 100%;

      @include mediaFluid(tablet) {
        width: auto;
      }

      span {
        font-family: 'Gotham Book';
        font-weight: bold;
        font-size: 13px;
        text-transform: uppercase;
        line-height: 13px;
        margin-bottom: 3px;

        @include mediaFluid(tablet) {
          position: absolute;
          top: -23px;
          right: 0;
          font-weight: normal;
          margin-bottom: 0;
          color: #E71F6C;
        }
      }

      b {
        font-family: 'Gotham';
        font-size: 19px;
        padding: 0 2px;
      }
    }
  }

  &__button {
    text-transform: uppercase;
    outline: none;
    font-weight: bold;
    cursor: pointer;
    border: 0;

    &--close {
      background-color: #fff;
      border: 2px solid #005CA9;
      color: #005CA9;
      font-size: .86em;
      padding: 11px 17px 10px;
      margin: 30px 0;

      &:hover {
        color: #009FEA;
        border-color: #009FEA;
      }

      @include mediaFluid(tablet) {
        margin: auto;
      }
    }

    &--select {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      align-items: center;
      font-size: 1.4em;
      color: #fff;
      font-weight: bold;
      background-color: #E71F6C;
      width: 100%;
      padding: 13px 10px;

      @include mediaFluid(tablet) {
        min-width: 200px;
        width: auto;
        padding: 25px 40px 23px;
      }

      &:hover {
        background-color: rgba(231 ,31, 108, .75);
      }
    }

    &--clear {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
      color: #005CA9;
      font-size: 13px;
      font-weight: bold;
      padding: 31px 0 28px;
      width: 100%;

      @include mediaFluid(tablet) {
        padding: 0;
        width: auto;
      }

      span {
        font-size: 9px;
        margin: -3px 6px 0 0;
      }

      &:hover {
        color: #009FEA;
      }
    }
  }

  .services-dropdown {
    font-weight: bold;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/booking/additionalServices/Modal.vue